import * as React from 'react';
import Lozenge from '@atlaskit/lozenge';

interface Props {
  credittype: string;
}

export const InvoiceRefundCreditNote = ({ credittype }: Props) => {
  let noteType: 'REFUNDED' | 'PARTIAL REFUND' | 'TAX REFUND' | 'SLA CREDIT';
  switch (credittype) {
    case 'full-item-refund':
      noteType = 'REFUNDED';
      break;
    case 'tax-only-refund':
      noteType = 'TAX REFUND';
      break;
    case 'partial-item-refund':
      noteType = 'PARTIAL REFUND';
      break;
    case 'SLA_CREDIT':
      noteType = 'SLA CREDIT';
  }
  return (
    <Lozenge appearance="inprogress" isBold={false}>
      {' '}
      {/*// @ts-ignore */}
      {noteType}
    </Lozenge>
  );
};
